<template>
  <div>
    <h-modal :visible="visible" :footer="null" @cancel="close">
      <template slot="title">
        <div style="text-align:center">
          {{ record.linkName ? record.linkName : '--' }}
        </div>
      </template>
      <div>
        <span>
          <span class="title">时限
            <a-tooltip placement="top">
              <template slot="title">
                <p>即时：当场完成，直接到下个步骤。</p>
                <p>n个工作日：最迟n个工作日能够通过此步骤。</p>
              </template>
              <a-icon type="question-circle" />
            </a-tooltip> :<span class="content" style="margin-left:10px">{{ record.handleTerm ? (record.handleTerm === '0' ? 即时 : record.handleTerm + '工作日') : '--' }}</span></span>
        </span>
        <span style="margin-left:50px">
          <span class="title">审批人：</span>
          <span class="content">{{ record.handlePerson ? record.handlePerson : '--' }}</span>
        </span>

      </div>
      <div style="margin-top:30px">
        <span class="title">审查标准</span>
        <p class="content" style="margin-top:10px">{{ record.handleStandard ? record.handleStandard : '--' }}</p>
        <!-- <p class="content" style="margin-top:10px">1.核对申请人是否符合申请条件；</p>
        <p class="content">2.依据办事指南中材料清单逐一核对是否齐全；</p>
        <p class="content">3.核对每个材料是否涵盖材料要求中涉及的内容和要素。</p> -->
      </div>
      <div style="margin-top:30px">
        <span class="title">办理结果</span>
        <p class="content" style="margin-top:10px">{{ record.handleResult ? record.handleResult : '--' }}</p>
      </div>
      <div style="background:#F3F7FF;height:64px;width:100%;font-size:22px;line-height:64px;text-align:center;cursor: pointer;color:#1777ff" @click="close">我知道了</div>
    </h-modal>
  </div>
</template>

<script>
import { HModal } from 'jpaas-component'
export default {
  components: {
    HModal
  },
  data () {
    return {
      visible: false,
      record: {}
    }
  },
  methods: {
    open (data) {
      this.visible = true
      this.record = data
    },
    close () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
}
.content {
  color: #666 !important;
  font-weight: normal;
}
</style>
